import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimLower',
})
export class TrimLowerPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return value?.trim().toLowerCase() ?? '';
  }
}
